<div class="service-detail-page faq-page">
    <div class="container">

        <header class="text-center" appFadeInReveal>
            <h1>Preguntas Frecuentes</h1>
            <div class="header-description">
                <p class="lead-text">
                    Es normal tener dudas antes de comenzar un proceso terapéutico.
                </p>
                <p>
                    Aquí he recopilado las preguntas más habituales sobre el funcionamiento de las sesiones,
                    tanto para adultos como para familias. Si tienes alguna otra inquietud, no dudes en escribirme.
                </p>
            </div>
        </header>

        <div class="faq-wrapper">
            @for (category of faqCategories; track category.title) {
            <section class="faq-category" appFadeInReveal>
                <h2>{{ category.title }}</h2>

                <div class="faq-list-container">
                    @for (item of category.items; track item.question) {
                    <div class="faq-accordion-item" [class.open]="item.isOpen">
                        <button class="faq-question" (click)="toggleFaq(item)" [attr.aria-expanded]="item.isOpen">
                            <h3>{{ item.question }}</h3>
                            <span class="icon-toggle"></span>
                        </button>

                        <div class="faq-answer-wrapper" [style.max-height]="item.isOpen ? '1000px' : '0'">
                            <div class="faq-answer" [innerHTML]="item.answer"></div>
                        </div>
                    </div>
                    }
                </div>
            </section>
            }
        </div>

        <div class="cta-container" appFadeInReveal>
            <p style="margin-bottom: 20px; font-size: 1.1rem;">¿Tienes alguna duda que no aparece aquí?</p>
            <a routerLink="/contacto" class="btn-primary">Contactar ahora</a>
        </div>

    </div>
</div>